require('core-js/fn/array/filter');
require('core-js/fn/array/includes');
require('core-js/fn/array/find');
require('core-js/fn/array/map');
require('core-js/fn/object/keys');



// WEBPACK FOOTER //
// ./src/polyfill.js